import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';
import SmsBadge from './SmsBadge.vue';

// 2026-05-20 — SMS Simulator dashboard (Agent-3 design §3.6).
// 2026-05-23 — Task 16.5: timeline UI + kind badges + OTP/temp-password
// copy buttons + filters (phone, tripId, studentPassengerId, sinceUtc, take).
// Reads SmsSimulatorMessages so QA can pick up OTPs/temp passwords without
// server SSH access. Shows the current SMS mode (Simulator vs. Live) so it's
// obvious when the table is no longer being written to. Auto-refreshes
// every 5 seconds so newly-triggered SMS appear without manual reload.

export default {
    name: 'SmsSimulator',
    mixins: [HelperMixin],
    components: { SmsBadge },

    data() {
        return {
            Items: [],
            Mode: 'Simulator',
            Phone: '',
            TripId: null,
            StudentPassengerId: null,
            SinceUtc: '',
            Take: 200,
            MissingEndpoint: false,
            _timer: null,
        };
    },

    computed: {
        ModeLabel() {
            return `الوضع: ${this.Mode || 'Simulator'}`;
        },
        ModeBadgeClass() {
            const m = (this.Mode || '').toLowerCase();
            if (m === 'live') return 'mode-live';
            if (m === 'disabled') return 'mode-off';
            return 'mode-sim';
        }
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // SMS Simulator is super-admin only — the backend SmsSimulatorController
        // forbids non-admins (it exposes every user's OTPs system-wide).
        if (!this.requireUserType([1])) return;
        await this.refresh();
        this._timer = setInterval(() => { this.refresh(); }, 5000);
    },

    beforeDestroy() {
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    },

    methods: {
        MarkerClass(kind) {
            switch (kind) {
                case 'Otp': return 'marker-otp';
                case 'Welcome': return 'marker-welcome';
                case 'Lifecycle': return 'marker-lifecycle';
                case 'Operational': return 'marker-operational';
                default: return 'marker-other';
            }
        },

        async refresh() {
            this.MissingEndpoint = false;
            try {
                const opts = {
                    take: this.Take || 200,
                };
                if (this.Phone) opts.phone = this.Phone;
                if (this.TripId) opts.tripId = this.TripId;
                if (this.StudentPassengerId) opts.studentPassengerId = this.StudentPassengerId;
                if (this.SinceUtc) opts.sinceUtc = new Date(this.SinceUtc).toISOString();

                const res = await this.$http.GetSmsSimulator(opts);
                const payload = res.data || {};
                this.Mode = payload.mode || 'Simulator';
                this.Items = payload.items || [];
            } catch (e) {
                const code = e && e.response ? e.response.status : 0;
                if (code === 404 || code === 405) {
                    this.MissingEndpoint = true;
                }
                this.Items = [];
            }
        },

        copy(text) {
            if (!text) return;
            try {
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(String(text));
                } else {
                    const ta = document.createElement('textarea');
                    ta.value = String(text);
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand('copy');
                    document.body.removeChild(ta);
                }
            } catch (e) {
                // swallow — copy is a UX nicety, not load-bearing.
            }
        },

        formatTime(t) {
            if (!t) return '—';
            // Africa/Tripoli is UTC+2 (no DST) — display in local school time.
            return moment(t).utcOffset(120).format('YYYY-MM-DD HH:mm:ss [طرابلس]');
        }
    }
};
